module.exports = __webpack_public_path__ + "img/exclamation-primary.8e1cf237.svg";